import {ajaxErrorAlert, ajaxPost, parceAjaxErrorResponse} from "./utils";
import {bsModal} from "./plugins";
import {ErrorSwal, getJsContext, getRecaptchaToken, getUrlTranslation} from "../app";

$(function () {
  $('#findPolicyNumberModalBtn').on('click', (e) => {
    e.preventDefault();

    const findPolicyNumberModal = bsModal("medium", {
      title: getJsContext('find_policy_number'),
      backdrop: "none",
      modalId: "findPolicyNumberModal",
    });

    ajaxPost(getUrlTranslation("/find-policy-number/"), {action: "html"})
      .then((response) => {
        $(findPolicyNumberModal).modal("content", response.html);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors).join("<br>"),
        }).then(() => {
          $(findPolicyNumberModal).modal("hide");
        });
      });
  });

  $(document).on('change', 'input[name=search_by]', (e) => {
    const radio = $(e.target);
    const label = radio.data('label');

    $('.personIdentificationLabel').text(label);
  });

  $(document).on('submit', '#findPolicyNumberForm', (e) => {
    e.preventDefault();

    const form = $(e.target);

    $('#findPolicyNumberResult').hide();
    $('#insuredPersonNameMasked').text('--');

    getRecaptchaToken(form, {position: "left top", extraClasses: "p-0"})
      .then(() => {
        const data = form.serializeArray();
        data.push({
          name: "action",
          value: "find",
        });
        form.loading({
          loadingText: getJsContext('finding') + '...',
          position: "left top",
          extraClasses: "p-0"
        })
        ajaxPost(getUrlTranslation('/find-policy-number/'), data, form)
          .then((response) => {
            $('#findPolicyNumberResult').show();
            $('#insuredPersonNameMasked').text(String(response['insured_person']));

            $('#policiesTable tbody').empty();

            response['policies'].forEach((policy) => {
              $('#policiesTable tbody').append(`
              <tr>
                <td class="text-nowrap align-middle py-2">${policy['policy_number']}</td>
                <td class="text-nowrap align-middle py-2">${policy['premium']} ${policy['currency']}</td>
                <td class="text-nowrap align-middle py-2">
                  <button class="checkPolicyNumberBtn btn btn-success text-nowrap" data-policy-number="${policy['policy_number']}">
                    <i class="far fa-credit-card me-2"></i>${getJsContext('make_payment')}
                  </button>
                </td>
                <td class="text-nowrap align-middle py-2">${policy['start_date_text']}</td>
              </tr>
            `)
            });
          })
          .catch((errors) => {
            ajaxErrorAlert(errors, form);
          });
      });
  });

  $(document).on('click', '.checkPolicyNumberBtn', (e) => {
    const button = $(e.currentTarget);
    const policyNumber = button.data('policy-number');
    const input = $('input[name=policy_number]');
    const form = $('#checkPolicyNumberForm');

    input.val(policyNumber);
    form.trigger('submit');

    $(button).closest('.modal').modal("hide");
  });
});